import { ErrorResponse } from 'src/app/shared/models/error.model';

function handleGenericHttpError(errorResponse: ErrorResponse): string {
    let genericErrorMsg = '';
    switch (errorResponse.errorCode) {
        case 401:
            genericErrorMsg = 'You are not authorized to access this page. This may happen due to timeout. Please login again';
            break;
        case 500:
            genericErrorMsg = `Some error occurred while executing your last operation.
                                Please try again. If the error persists, please contact DE International`;
            break;
    }
    return genericErrorMsg;
}

export default handleGenericHttpError;
